import { useEffect, useState } from "react"
import type { ErrorFetch, SuccessFetch } from "../../../../../../../../../../types"
import { DataList } from "../../../../../../types"
import { useApi } from "../../../../../../../../../../utils"

export function useDetail() {
  const api = useApi()
  const [data, setData] = useState<DataList | null>(null)
  const [dataError, setError] = useState<string | undefined>(undefined)
  const [isLoading, setLoading] = useState(true)

  useEffect(() => {
    api.get("/typetax/").then((res: SuccessFetch<{
      payload: {
        type_tax_id: number
        type_tax_code: string
        type_tax_name: string
        description: string,
      }
    }>) => {
      const data = res.data.payload

      setData(data)
    }).catch((err: ErrorFetch<{ detail: { message: string } }>) => {
      setError(err.response.data.detail.message)
    }).finally(() => {
      setLoading(false)
    })
  
    return () => {
      setData(null)
      setError(undefined)
      setLoading(true)
    }

    // eslint-disable-next-line
  }, [])

  return { data, dataError, isLoading }
}